import { t } from 'i18next';
import {
  dbFieldType,
  FILTER_EMPTY_PLACEHOLDER,
  FILTER_NOT_EMPTY_PLACEHOLDER,
  filterFieldDataType,
  filterFieldSuffix,
  translationSuffixes
} from '../../../constants';
import moment from 'moment';
import i18n from '../../../i18n';

const encode = encodeURIComponent;

export const generateQueryDSLQuery = (
  activeFilters,
  possibleFiltersList = [],
  filterLogicalOperator
) => {
  let search = '';
  let searchReadable = '';
  let fieldCount = 0;

  let fields = JSON.parse(JSON.stringify(possibleFiltersList));
  fields.push({
    label: 'id',
    value: 'ID',
    key: 'ID',
    filterType: { type: 'MULTIPLE_AUTO_COMPLETE', options: null }
  });

  fields.forEach(entry => {
    let hasBetweenVal = false;
    let hasAndVal = false;
    let searchExpression = '';
    let searchExpressionReadable = '';
    Object.keys(activeFilters).forEach(key => {
      let value = activeFilters[key];
      if (value !== '') {
        if (
          key == entry.key ||
          ((key.lastIndexOf(filterFieldSuffix.more_than) !== -1 ||
            key.lastIndexOf(filterFieldSuffix.less_than) !== -1) &&
            key.startsWith(entry.key))
        ) {
          let unit = i18n.exists(entry.label + translationSuffixes.unit)
            ? ' ' + t(entry.label + translationSuffixes.unit)
            : '';
          let readableValue = value + unit;
          if (value !== FILTER_EMPTY_PLACEHOLDER && value !== FILTER_NOT_EMPTY_PLACEHOLDER) {
            if (entry.filterType.type === filterFieldDataType.date) {
              let date = new Date(value);
              value = date.getTime();
              readableValue = moment(date).format('DD-MM-YYYY');
              if (value === null || value === 0) {
                return;
              }
            }
            if (key.lastIndexOf(filterFieldSuffix.more_than) !== -1) {
              searchExpression += `${(hasAndVal ? '|AND|' : '') +
                key.replace(filterFieldSuffix.more_than, '')}>${value}`;
              searchExpressionReadable += `${(hasAndVal ? t('filters.readable.and') : '') +
                t('filters.readable.is.more.than', {
                  label: t(entry.label),
                  value: readableValue
                })}`;
              hasBetweenVal = true;
            } else if (key.lastIndexOf(filterFieldSuffix.less_than) !== -1) {
              searchExpression += `${(hasBetweenVal ? '|AND|' : '') +
                key.replace(filterFieldSuffix.less_than, '')}<${value}`;
              searchExpressionReadable += `${(hasBetweenVal ? t('filters.readable.and') : '') +
                t('filters.readable.is.less.than', {
                  label: t(entry.label),
                  value: readableValue
                })}`;
              hasAndVal = true;
            } else if (
              (entry.filterType.type === filterFieldDataType.multiple_choice ||
                entry.filterType.type === filterFieldDataType.multiple_auto_complete) &&
              value.length > 0
            ) {
              let translationCode =
                entry.filterType.type === filterFieldDataType.multiple_auto_complete
                  ? 'filters.readable.is.one.of.the.following'
                  : 'filters.readable.is.containing.one.of.the.following';
              searchExpression += `${key}#${value.map(e => e.value).join(';')}`;
              searchExpressionReadable += t(translationCode, {
                label: t(entry.label),
                value: value.map(e => `<span class="ui yellow basic label">${t(e.label)}</span>`)
              });
            } else if (
              (entry.filterType.type === filterFieldDataType.multiple_auto_complete_contains ||
                entry.filterType.type ===
                  filterFieldDataType.multiple_auto_complete_or_text_contains) &&
              value.length > 0
            ) {
              searchExpression += `${key}@${value.map(e => e.value).join(';')}`;
              searchExpressionReadable += t('filters.readable.is.containing.one.of.the.following', {
                label: t(entry.label),
                value: value.map(
                  e =>
                    `<span class="ui yellow basic label">${t(e.label ? e.label : e.value)}</span>`
                )
              });
            } else if (
              (entry.filterType.type === filterFieldDataType.boolean_dropdown) &&
              value != undefined
            ) {
              searchExpression += `${key}:${value}`;
              searchExpressionReadable += t('filters.readable.is', {
                label: t(entry.label),
                value: t(value == dbFieldType.true ? 'filters.true' : value == dbFieldType.false ? 'filters.false' : 'filters.all')
              });
            } else if (
              (entry.filterType.type === filterFieldDataType.boolean) &&
              value != undefined
            ) {
              const booleanValue = dbFieldType[value];
              searchExpression += `${key}:${booleanValue}`;
              searchExpressionReadable += t('filters.readable.is', {
                label: t(entry.label),
                value: t(booleanValue == dbFieldType.true ? 'filters.true' : booleanValue == dbFieldType.false ? 'filters.false' : 'filters.all')
              });
            } else {
              if (value.length > 0) {
                searchExpression += `${key}~${value.trim()}`;
                searchExpressionReadable += t('filters.readable.contains', {
                  label: t(entry.label),
                  value: value.trim()
                });
              }
            }
          } else {
            //Empty or not empty filters
            if (value.length > 0) {
              searchExpression += `${key}~${value}`;
              searchExpressionReadable += searchExpressionReadable += t('filters.readable.is', {
                label: t(entry.label),
                value: t(value === FILTER_EMPTY_PLACEHOLDER ? 'filters.empty' : 'filters.non.empty')
              });
            }
          }
        }
      }
    });
    if (searchExpression !== '') {
      if (fieldCount === 0) {
        search = searchExpression;
        searchReadable = searchExpressionReadable;
        fieldCount += 1;
      } else {
        search += `|${filterLogicalOperator}|${searchExpression}`;
        searchReadable += `<br/><span class="ui green label">${filterLogicalOperator}</span>${searchExpressionReadable}`;
      }
    }
  });

  return { search: search, searchReadable: searchReadable };
};

const generateJavaSearchQuery = params => {
  const query = generateQueryDSLQuery(
    params.filters,
    params.possibleFieldsList,
    params.filterLogicalOperator
  ).search;

  return (
    (params.visibleColumns ? `?visibleColumns=${encode(params.visibleColumns)}` : '') +
    (params.visibleFields ? `&visibleFields=${encode(params.visibleFields)}` : '') +
    (query ? `&search=${encode(query)}` : '') +
    (params.sort.sortDirection
      ? `&sortDirection=${encode(params.sort.sortDirection)}&sortField=${encode(
          params.sort.sortField
        )}`
      : '') +
    (params.pageSize ? `&pageSize=${encode(params.pageSize)}` : '') +
    (params.page ? `&page=${encode(params.page)}` : '') +
    (params.dataViewId ? `&dataViewId=` + encode(params.dataViewId) : '') +
    (params.filterValues ? `&filterValues=` + encode(JSON.stringify(params.filterValues)) : '')
  );
};

export const generateJavaSearchDto = params => {
  const query = generateQueryDSLQuery(
    params.filters,
    params.possibleFieldsList,
    params.filterLogicalOperator
  ).search;

  let javaSearchDto = {
    visibleColumns: params.visibleColumns ? params.visibleColumns : '',
    visibleFields: params.visibleFields ? params.visibleFields : '',
    search: query ? query : '',
    sortDirection: params.sort.sortDirection ? params.sort.sortDirection : '',
    sortField: params.sort.sortDirection ? params.sort.sortField : '',
    pageSize: params.pageSize ? params.pageSize : 10,
    page: params.page ? params.page : 1,
    dataViewId: params.dataViewId ? params.dataViewId : 0,
    filterValues: params.filterValues ? JSON.stringify(params.filterValues) : ''
  };

  return javaSearchDto;
};

export default generateJavaSearchQuery;
